import {lazy} from 'react';

export const FloatingAlertLazy = lazy(() => import(/* webpackChunkName: "floatingAlert" */ '.'));
